// import { RequireAutorization } from './routerAuth'

export default {
  path: '/manuais',
  component: () => import(/* webpackChunkName: "Manuals" */ './Layout.vue'),
  children: [
    {
      path: '/',
      name: 'Manuals',
      component: () => import(/* webpackChunkName: "Manuals" */'./Index.vue'),
      meta: {
        title: 'Manuais',
        subject: 'Manual',
        action: 'list',
        newTitle: 'Adicionar manual',
        newRoute: 'ManualNew',
      },
    },
    {
      path: 'criar',
      name: 'ManualNew',
      component: () => import(/* webpackChunkName: "Manuals" */'./New.vue'),
      meta: {
        title: 'Criar manual',
        subject: 'Manual',
        action: 'create',
        closeRoute: 'Manuals',
      },
    },
    {
      path: ':manualId',
      name: 'ManualShow',
      component: () => import(/* webpackChunkName: "Manuals" */'./Show.vue'),
      meta: {
        title: 'Exibir manual',
        subject: 'Manual',
        action: 'read',
        closeRoute: 'Manuals',
      },
    },
    {
      path: ':manualId/editar',
      name: 'ManualEdit',
      component: () => import(/* webpackChunkName: "Manuals" */'./Edit.vue'),
      meta: {
        title: 'Editar manual',
        subject: 'Manual',
        action: 'update',
        closeRoute: 'Manuals',
      },
    },
  ],
  // beforeEnter: RequireAutorization
}
